import React, { useEffect, useState } from 'react';
import { LOGO } from '../mock';

export default function LoadingScreen() {
  const [hidden, setHidden] = useState(false);

  useEffect(() => {
    const t = setTimeout(() => setHidden(true), 2200);
    return () => clearTimeout(t);
  }, []);

  return (
    <div className={`loader-screen ${hidden ? 'hidden' : ''}`}>
      <div className="loader-inner">
        <div style={{ position: 'relative' }}>
          <div className="loader-logo">
            <img src={LOGO} alt="Vistora" style={{ width: '100%', height: '100%', objectFit: 'cover' }} />
          </div>
          <div className="orbit" style={{ width: 120, height: 120 }}>
            <div className="orbit-dot" style={{ top: '50%', left: '50%', marginLeft: -4, marginTop: -4 }} />
            <div className="orbit-dot o2" style={{ top: '50%', left: '50%', marginLeft: -4, marginTop: -4 }} />
          </div>
        </div>
        <div>
          <div className="loader-title">VISTORA</div>
          <div className="loader-tag" style={{ marginTop: 8 }}>Crafting Visual Impact</div>
        </div>
        <div className="loader-bar"><span /></div>
      </div>
    </div>
  );
}
